<template>
  <pt-gene-lab-order class="pt-gene-lab-order__withData" ref="detail" @getOrderExportExcel="getOrderExportExcel" :exportLoading="exportLoading"></pt-gene-lab-order>
</template>

<script>
import PtGeneLabOrder from './index'
export default {
  name: 'pt-gene-lab-order__withData',
  components: {
    'pt-gene-lab-order': PtGeneLabOrder
  },
  data () {
    return {
      exportLoading: false
    }
  },
  methods: {
    getOrderExportExcel (params) {
      let data = {
        ...params
      }
      this.exportLoading = true
      this.$store.dispatch('getOrderExportExcel', data).then(res => {
        this.$message.success('样本导出成功')
        this.exportLoading = false
      }).catch(err => {
        this.$message.success(err || '样本导出失败')
        this.exportLoading = false
      })
    }
  }
}
</script>
